import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';

interface OrgSearchState {
  query: string;
  setQuery: (query: string) => void;
  clearQuery: () => void;
}

const Ctx = createContext<OrgSearchState | null>(null);

export function OrgSearchProvider({ children }: { children: ReactNode }) {
  const [query, setQuery] = useState('');
  const clearQuery = useCallback(() => setQuery(''), []);
  const value = useMemo(() => ({ query, setQuery, clearQuery }), [query, clearQuery]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useOrgSearch(): OrgSearchState {
  const value = useContext(Ctx);
  if (!value) throw new Error('useOrgSearch must be used inside OrgSearchProvider');
  return value;
}
